var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "CSChatThai", staticStyle: { background: "#2562af" } },
    [
      _c(
        "div",
        { staticStyle: { background: "#2562af !important", padding: "10px" } },
        [
          _c(
            "v-btn",
            {
              staticStyle: { margin: "0 !important" },
              attrs: { icon: "" },
              on: {
                click: function($event) {
                  return _vm.goback()
                }
              }
            },
            [
              _c(
                "v-icon",
                {
                  staticClass: "white--text",
                  staticStyle: { "font-size": "24px" }
                },
                [_vm._v("chevron_left")]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticStyle: {
                color: "white",
                "font-weight": "800",
                "margin-left": "25vw"
              }
            },
            [_vm._v("โปรไฟล์")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticStyle: {
            padding: "10px",
            "border-top-left-radius": "20px",
            "border-top-right-radius": "20px",
            background: "#fafafa"
          }
        },
        [
          _c(
            "v-layout",
            { attrs: { row: "", wrap: "" } },
            [
              _c(
                "v-flex",
                { attrs: { xs12: "", xl12: "", lg12: "", md12: "", sm12: "" } },
                [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "justify-content": "center"
                      }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "image-upload" },
                        [
                          _vm.my_profile_picture
                            ? _c("v-img", {
                                staticClass:
                                  "grey lighten-2 imageProfile alligator-turtle",
                                attrs: {
                                  src: _vm.my_profile_picture,
                                  "aspect-ratio": "1"
                                },
                                on: { click: _vm.uppic },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "placeholder",
                                      fn: function() {
                                        return [
                                          _c(
                                            "v-layout",
                                            {
                                              attrs: {
                                                "fill-height": "",
                                                "align-center": "",
                                                "justify-center": "",
                                                "ma-0": ""
                                              }
                                            },
                                            [
                                              _c("v-progress-circular", {
                                                attrs: {
                                                  indeterminate: "",
                                                  color: "grey lighten-5"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ]
                                      },
                                      proxy: true
                                    }
                                  ],
                                  null,
                                  false,
                                  1258913907
                                )
                              })
                            : _c("v-img", {
                                staticClass:
                                  "grey lighten-2 imageProfile alligator-turtle",
                                on: { click: _vm.uppic }
                              }),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              staticClass: "SettingImgBtn",
                              attrs: { for: "file-input" }
                            },
                            [_vm._v("\n    เปลี่ยนรูป\n  ")]
                          ),
                          _vm._v(" "),
                          _c("input", {
                            attrs: {
                              id: "file-input",
                              type: "file",
                              accept: "image/*"
                            },
                            on: { change: _vm.previewImageprofiles }
                          })
                        ],
                        1
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticStyle: { "margin-top": "10px" } }, [
                    _c(
                      "div",
                      {
                        staticClass: "detailBG",
                        on: {
                          click: function($event) {
                            return _vm.gotopath("/edit_displayname")
                          }
                        }
                      },
                      [
                        _c("p", { staticClass: "HeadersDetail" }, [
                          _vm._v("ชื่อแสดง")
                        ]),
                        _vm._v(" "),
                        _c("p", { staticClass: "Detail" }, [
                          _vm._v(_vm._s(_vm.displayname) + " ")
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "detailBG",
                        on: {
                          click: function($event) {
                            return _vm.gotopath("/edit_status")
                          }
                        }
                      },
                      [
                        _c("p", { staticClass: "HeadersDetail" }, [
                          _vm._v("สถานะ")
                        ]),
                        _vm._v(" "),
                        _c("p", { staticClass: "Detail" }, [
                          _vm._v(_vm._s(_vm.status ? _vm.status : "-") + " ")
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "detailBGEmail" }, [
                      _c("p", { staticClass: "HeadersDetail" }, [
                        _vm._v("อีเมล")
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "Detail" }, [
                        _vm._v(_vm._s(_vm.email ? _vm.email : "-") + " ")
                      ])
                    ])
                  ])
                ]
              )
            ],
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6be9448e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6be9448e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mail/My_Profile.vue
// module id = null
// module chunks = 